__turbopack_context__.v({
  "disabled-property": "SelectableTextBox-module-scss-module__uyrt3q__disabled-property",
  "property-content-selected": "SelectableTextBox-module-scss-module__uyrt3q__property-content-selected",
  "property-content-size-wrapper": "SelectableTextBox-module-scss-module__uyrt3q__property-content-size-wrapper",
  "selected-property": "SelectableTextBox-module-scss-module__uyrt3q__selected-property",
});
